{
    "ConsidermovedtounresolvedasoverflowedLabel": "Betrachten Sie Anrufe, die auf nicht aufgelöste Geräte verschoben wurden, als übergelaufen:",
    "StatisticCalculations_SectionHeader": "Statistische Berechnungen",
    "StatisticCalculations_SectionPara": "Sie können wählen, ob Anrufe als übergelaufen oder abgebrochen betrachtet werden sollen, wenn die Anwendung die Modellierung von Anrufen, die an nicht überwachte oder unbekannte Gerätepositionen verlegt wurden, absichtlich beendet.",
    "NAME": "StatisticCalculations"
}